import { FEEDBACK_DOWNLOADED, FEEDBACK_FAILED, FEEDBACK_PENDING } from './types';
import FeedbacksApiService from '../../services/api/FeedbacksApiService';
import { handleError } from '../infos/actions';

export function feedbackPendingAction() {
  return { type: FEEDBACK_PENDING };
}

export function feedbackFailedAction(error) {
  return {
    type: FEEDBACK_FAILED,
    payload: { error },
  };

}

export function feedbackDownloadedAction(content) {
  return {
    type: FEEDBACK_DOWNLOADED,
    payload: { content },
  };
}

export function getFeedbacks(authUserToken, role) {
  return (dispatch) => {
    dispatch(feedbackPendingAction());
    return FeedbacksApiService.getFeedbacks(authUserToken, role)
      .then((data) => {
        dispatch(feedbackDownloadedAction(data));
        return data;
      }) .catch((error) => {
        dispatch(feedbackFailedAction(error));
        dispatch(handleError(error));
      })
  }
}



// WEBPACK FOOTER //
// ./src/store/feedbacks/actions.js